export default {"src":"/_next/static/media/photoshop.c2d8557c.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};